import {
  DialogTitle,
  IconButton,
  DialogContent,
  List,
  ListItemText,
  DialogActions,
  Stack,
  Button,
} from "@mui/material";
import PropTypes from "prop-types";
import React from "react";
import { buttonColors, colors } from "../../../utility/types/constant";
import { BootstrapDialog } from "../notification-modal/styles";
import CloseIcon from "@mui/icons-material/Close";

interface LeaderApplicationTermsModalProps {
  sx?: any;
  title?: string;
  open: boolean;
  onAgree: () => any;
  onDisAgree: () => any;
  handleClose: () => void;
}

const LeaderApplicationTermsModal = (
  props: LeaderApplicationTermsModalProps
) => {
  const { sx, title, open, handleClose, onAgree, onDisAgree } = props;

  const handleAgree = () => {
    onAgree();
    handleClose();
  };

  const handleDisAgree = () => {
    onDisAgree();
    handleClose();
  };

  return (
    <React.Fragment>
      <BootstrapDialog
        onClose={handleClose}
        open={open}
        aria-labelledby="customized-dialog-title"
        sx={{
          ...sx,
          width: "80",
        }}
        fullWidth
      >
        <DialogTitle
          sx={{ m: 0, p: 2, fontSize: "1.5rem" }}
          id="customized-dialog-title"
        >
          {title}
        </DialogTitle>

        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: colors.white,
            backgroundColor: colors.cancel,
            "&:hover": {
              color: colors.white,
              backgroundColor: colors.cancel,
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <DialogContent dividers sx={{ fontSize: "1.1rem" }}>
          <List sx={{ listStyleType: "disc" }}>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Acceptance of Role: By accepting the role of a circle/group leader
              on the , you agree to abide by the terms and responsibilities
              outlined in this agreement.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Leadership Responsibilities: As a leader, you are responsible for
              inviting members, managing group settings, and ensuring a fair and
              transparent operation of your group.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Compliance with Platform Rules: You must adhere to all platform
              rules and ensure that your group follows the same standards.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Conflict Resolution: As a leader, you are responsible for
              addressing and resolving any disputes or issues that arise within
              your group.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Data Confidentiality: You must maintain the confidentiality of
              member information and not disclose it outside the platform
              without consent.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Liability: You agree to not hold the platform liable for any
              disputes or issues that arise as a result of group activities.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Termination of Role: Your role as a leader can be terminated by
              the platform for any breach of these terms.
            </ListItemText>
            <ListItemText sx={{ display: "list-item", ml: 3 }}>
              Amendments: These terms may be updated from time to time, with
              notice provided to you in accordance with our policy.
            </ListItemText>
          </List>
        </DialogContent>

        <DialogActions sx={{ justifyContent: "center" }}>
          <Stack direction="row" spacing={10} sx={{ mb: 1 }}>
            <Button
              size="large"
              onClick={handleAgree}
              variant="contained"
              sx={{
                bgcolor: buttonColors.secondPrimary,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.secondPrimary,
                  color: colors.white,
                },
              }}
            >
              Agree
            </Button>

            <Button
              size="large"
              onClick={handleDisAgree}
              variant="contained"
              sx={{
                bgcolor: buttonColors.persianRed,
                color: colors.white,
                "&:hover": {
                  bgcolor: buttonColors.persianRed,
                  color: colors.white,
                },
              }}
            >
              Disagree
            </Button>
          </Stack>
        </DialogActions>
      </BootstrapDialog>
    </React.Fragment>
  );
};

LeaderApplicationTermsModal.propTypes = {
  title: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  sx: PropTypes.any,
  onAgree: PropTypes.func.isRequired,
  onDisAgree: PropTypes.func.isRequired,
};

export default LeaderApplicationTermsModal;
